///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.checkbooks = abcsetup.promos.checkbooks || {};
abcsetup.promos.checkbooks.workflow = abcsetup.promos.checkbooks.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.checkbooks.workflow = {
    init() {
        abcsetup.setTitle('Promotional Checkbook');

        abcsetup.promos.checkbooks.setupPromoSupplierItemsModal(abcsetup.userRole.class !== 'promo_analyst');
        abcsetup.promos.checkbooks.setupAccordions();

        this.setupApproveButton();
        this.setupRejectButton();
    },

    /**
     * In order to support a hidden rejection-comments, field, we needed to also use a hidden form_action field (instead of using submit button names and values).
     */
    setupApproveButton() {
        $('#btn-approve').on('click', e => {
            e.preventDefault();
            $(e.target.form.form_action).val('approve');
            e.target.form.submit();
        });
    },

    /**
     * When reject button is clicked, ask for some info.
     */
    setupRejectButton() {
        $('#btn-reject').on('click', e => {
            e.preventDefault();
            const form = e.target.form;

            const handleClose = ([clickedOk, inputText]) =>
                clickedOk && $(form.rejection_comment).val(inputText).get(0).form.submit();

            $(form.form_action).val('reject');
            abcsetup.alerts.prompt('Reject Promo Checkbook', 'Reason for rejection:', handleClose, false, false, {textarea: true})
        });
    },
}
